import { IconArrowLeft, IconFile, IconX } from "@tabler/icons-react";
import type { FileToStorydocStep } from "../stores";

const SUBTITLE: Record<FileToStorydocStep, string> = {
  source: "Your file will be imported as a Storydoc document.",
  uploading: "Your file will be imported as a Storydoc document.",
  selecting: "Select the pages you want to convert",
  choosing: "Choose your preferred version for each slide",
  error: "Your file will be imported as a Storydoc document.",
};

// Deck imports land in a story that already exists, so the copy says so.
const DECK_SUBTITLE: Record<FileToStorydocStep, string> = {
  ...SUBTITLE,
  source: "Your file will be imported into this deck.",
  uploading: "Your file will be imported into this deck.",
  selecting: "Select the pages you want to import",
  error: "Your file will be imported into this deck.",
};

const CORNER_BUTTON_CLASS =
  "tw-absolute tw-top-6 tw-flex tw-size-9 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-blue tw-shadow-sm tw-outline tw-outline-1 tw-outline-offset-0 tw-outline-blue/5 hover:tw-bg-blue-50";

export const ImportDialogHeader = ({
  step,
  isDeck = false,
  fileName,
  onBack,
  onClose,
}: {
  step: FileToStorydocStep;
  isDeck?: boolean;
  fileName?: string | null;
  onBack?: () => void;
  onClose: () => void;
}) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-gap-6 tw-text-center">
    {onBack && (
      <button
        type="button"
        onClick={onBack}
        aria-label="Back"
        className={CORNER_BUTTON_CLASS + " tw-left-6"}
      >
        <IconArrowLeft className="tw-size-4" />
      </button>
    )}
    <button
      type="button"
      onClick={onClose}
      aria-label="Close"
      className={CORNER_BUTTON_CLASS + " tw-right-6"}
    >
      <IconX className="tw-size-4" />
    </button>
    {fileName && (
      <span className="tw-inline-flex tw-h-[22px] tw-max-w-full tw-items-center tw-gap-1 tw-rounded-full tw-bg-violet-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-leading-4 tw-text-violet-700">
        <IconFile className="tw-size-3 tw-shrink-0 !tw-fill-none tw-text-violet-700" />
        <span className="tw-truncate">{fileName}</span>
      </span>
    )}
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <div className="tw-flex tw-items-center tw-gap-4">
        <h2 className="tw-m-0 tw-font-sans tw-text-3xl tw-font-semibold tw-text-blue">
          {isDeck ? "Import slides" : "Convert your file into Storydoc"}
        </h2>
        <span className="tw-inline-flex tw-h-[22px] tw-items-center tw-rounded-lg tw-bg-blue-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-leading-4 tw-text-blue">
          Beta
        </span>
      </div>
      <p className="tw-m-0 tw-text-base tw-text-blue-500">
        {(isDeck ? DECK_SUBTITLE : SUBTITLE)[step]}
      </p>
    </div>
  </div>
);
